import { atom } from 'recoil';
export const wordReplacerState = atom({
    key: 'wordReplacerState_keywords',
    default: {
        isLoaded: false,
        keywords: null
    }
});
